/* ============================================================
   WIMBUSH WISHLIST PAGE
   Loads wishlist from localStorage, fetches products via Shopify API
   ============================================================ */

(function () {
  'use strict';

  const WISHLIST_KEY = 'wimbush_wishlist';
  const grid = document.getElementById('wimbushWishlistGrid');
  const emptyState = document.getElementById('wimbushWishlistEmpty');
  const loadingState = document.getElementById('wimbushWishlistLoading');
  const countEl = document.getElementById('wimbushWishlistCount');

  if (!grid) return;

  function getWishlist() {
    try {
      const stored = localStorage.getItem(WISHLIST_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
      updateHeaderBadge();
    } catch (e) {
      console.warn('Wishlist save failed:', e);
    }
  }

  function updateHeaderBadge() {
    const count = getWishlist().length;
    document
      .querySelectorAll('.wimbush-wishlist-badge, [data-wishlist-badge], .wishlist-badge, [data-wishlist-count]')
      .forEach((badge) => {
        badge.textContent = count;
        badge.style.display = count > 0 ? 'flex' : 'none';
      });
  }

  async function fetchProduct(handle) {
    try {
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) throw new Error('Product not found');
      return await response.json();
    } catch (e) {
      console.warn('Failed to fetch product:', handle, e);
      return null;
    }
  }

  function formatMoney(cents, format) {
    if (typeof cents !== 'number') return '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || '£{{amount}}';

    function defaultTo(value, defaultValue) {
      return value == null || value !== value ? defaultValue : value;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal = defaultTo(decimal, '.');
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      const parts = number.split('.');
      const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
      const centsAmount = parts[1] ? decimal + parts[1] : '';
      return dollarsAmount + centsAmount;
    }

    let value = '';
    const match = formatString.match(placeholderRegex);
    switch (match && match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  async function addToCart(variantId, button) {
    try {
      button.disabled = true;
      button.querySelector('span').textContent = 'Adding...';

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId), quantity: 1 }]
        })
      });

      if (!response.ok) throw new Error('Add failed');

      const cart = await response.json();

      // Update cart badge
      const countResponse = await fetch('/cart.js');
      const cartData = await countResponse.json();
      document
        .querySelectorAll('.cart-bubble__text, .cart-count-bubble, [data-cart-count], .cart-count, .theme-drawer__badge')
        .forEach((badge) => {
          badge.textContent = cartData.item_count;
          if (cartData.item_count > 0) {
            badge.style.display = '';
            badge.classList.remove('visually-hidden', 'hidden');
          }
        });

      button.querySelector('span').textContent = '✓ Added';
      button.style.background = '#0F3B36';
      button.style.borderColor = '#0F3B36';

      setTimeout(() => {
        button.querySelector('span').textContent = 'Add to Cart';
        button.style.background = '';
        button.style.borderColor = '';
        button.disabled = false;
      }, 1800);
    } catch (e) {
      button.querySelector('span').textContent = 'Try Again';
      button.style.background = '#a33';
      button.style.borderColor = '#a33';
      setTimeout(() => {
        button.querySelector('span').textContent = 'Add to Cart';
        button.style.background = '';
        button.style.borderColor = '';
        button.disabled = false;
      }, 1800);
    }
  }

  function removeFromWishlist(productId) {
    const list = getWishlist().filter((item) => String(item.id) !== String(productId));
    saveWishlist(list);
  }

  function createProductCard(product) {
    const card = document.createElement('div');
    card.className = 'wimbush-wishlist-card';
    card.dataset.productId = product.id;

    const imageUrl = product.featured_image
      ? product.featured_image.replace(/(\.\w+)$/, '_800x800$1')
      : '';

    const price = formatMoney(product.price);
    const compareAt = product.compare_at_price ? formatMoney(product.compare_at_price) : null;
    const onSale = compareAt && product.compare_at_price > product.price;

    const availableVariant = product.variants.find((v) => v.available) || product.variants[0];

    let badgeHTML = '';
    if (!product.available) {
      badgeHTML = '<span class="wimbush-wishlist-badge-tag wimbush-wishlist-badge-tag--sold">Sold Out</span>';
    } else if (onSale) {
      badgeHTML = '<span class="wimbush-wishlist-badge-tag wimbush-wishlist-badge-tag--sale">Sale</span>';
    }

    card.innerHTML = `
      <div class="wimbush-wishlist-img-wrap">
        <a href="${product.url}" class="wimbush-wishlist-img-link">
          ${imageUrl ? `<img src="${imageUrl}" alt="${product.title}" loading="lazy">` : ''}
        </a>
        ${badgeHTML}
        <button type="button" class="wimbush-wishlist-remove" aria-label="Remove from wishlist" data-remove-id="${product.id}">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="wimbush-wishlist-info">
        <div class="wimbush-wishlist-cat">${product.type || 'Leather Essentials'}</div>
        <a href="${product.url}" class="wimbush-wishlist-name">${product.title}</a>
        <div class="wimbush-wishlist-price-row">
          <span class="wimbush-wishlist-price">${price}</span>
          ${onSale ? `<span class="wimbush-wishlist-price-alt">${compareAt}</span>` : ''}
        </div>
        <button type="button" class="wimbush-wishlist-add" data-variant-id="${availableVariant.id}" ${!product.available ? 'disabled' : ''}>
          <span>${product.available ? 'Add to Cart' : 'Sold Out'}</span>
        </button>
      </div>
    `;

    // Remove button
    card.querySelector('.wimbush-wishlist-remove').addEventListener('click', function () {
      const id = this.dataset.removeId;
      removeFromWishlist(id);
      card.style.opacity = '0';
      card.style.transform = 'scale(0.9)';
      setTimeout(() => {
        card.remove();
        checkEmpty();
      }, 300);
    });

    // Add to cart button
    const addBtn = card.querySelector('.wimbush-wishlist-add');
    if (addBtn && !addBtn.disabled) {
      addBtn.addEventListener('click', function () {
        addToCart(this.dataset.variantId, this);
      });
    }

    return card;
  }

  function checkEmpty() {
    const remaining = grid.querySelectorAll('.wimbush-wishlist-card').length;
    if (remaining === 0) {
      grid.style.display = 'none';
      emptyState.style.display = 'block';
    } else {
      grid.style.display = 'grid';
      emptyState.style.display = 'none';
    }
    if (countEl) {
      countEl.textContent = remaining + ' item' + (remaining !== 1 ? 's' : '');
    }
  }

  async function renderWishlist() {
    const wishlist = getWishlist();

    if (loadingState) loadingState.style.display = 'none';

    if (wishlist.length === 0) {
      grid.style.display = 'none';
      emptyState.style.display = 'block';
      if (countEl) countEl.textContent = '0 items';
      return;
    }

    // Fetch all products in parallel
    const products = await Promise.all(wishlist.map((item) => fetchProduct(item.handle)));
    const validProducts = products.filter(Boolean);

    if (validProducts.length === 0) {
      grid.style.display = 'none';
      emptyState.style.display = 'block';
      if (countEl) countEl.textContent = '0 items';
      return;
    }

    grid.innerHTML = '';
    validProducts.forEach((product) => {
      grid.appendChild(createProductCard(product));
    });

    grid.style.display = 'grid';
    emptyState.style.display = 'none';
    if (countEl) {
      countEl.textContent = validProducts.length + ' item' + (validProducts.length !== 1 ? 's' : '');
    }
  }

  // Init
  updateHeaderBadge();
  renderWishlist();
})();